<template>
  <div class="surveillance-precaution">
<!--  {{caseData}}
  {{clientData}}
  {{precautions}}-->
    <el-table
      :data="clientData.precautionDetails"
      border
      style="width: 100%"
      >
      <el-table-column
        label="Precaution">
        <template scope="scope">
          <div class="case-note-content">{{ precautionById(scope.row.precautionId) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="Start Date"
        prop="created"
        width="120">
        <template scope="scope">
  <!--            {{ scope.row.created | moment('DD-MM-YYYY') }}-->
        </template>
      </el-table-column>
      <el-table-column
        label="End Date"
        prop="created"
        width="120">
        <template scope="scope">
  <!--            {{ scope.row.created | moment('DD-MM-YYYY') }}-->
        </template>
      </el-table-column>
      <el-table-column
        label="Unit"
        prop="created"
        width="120">
        <template scope="scope">
  <!--            {{ scope.row.created | moment('DD-MM-YYYY') }}-->
        </template>
      </el-table-column>
      <el-table-column
        label="Room"
        prop="created"
        width="120">
        <template scope="scope">
  <!--            {{ scope.row.created | moment('DD-MM-YYYY') }}-->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'surveillance-precaution',
  props: ['caseData', 'clientData', 'precautions'],
  data: function () {
    return {
    }
  },
  methods: {
    precautionById: function (precautionId) {
      var name = ''
      this.precautions.forEach(function (p) {
        if (p.id === precautionId) {
          name = p.displayText
        }
      })

      return name
    }
  }
}
</script>
<style scoped>
div {
    line-height: 3em;
}

.clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

.clearfix {
    clear: both;
    margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// SurveillancePrecaution.vue?57df6b9d